import customersApi from '../../api/CustomersApi';

const state = {
  churnValidated: false,
};

const actions = {
  churnCustomer() {
    return customersApi.churn();
  },
  async setChurnValidated({ commit }, churnValidated) {
    commit('setChurnValidated', { churnValidated });
  },
};

// mutations
const mutations = {
  setChurnValidated(state, { churnValidated }) {
    state.churnValidated = churnValidated; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/churn.js